import { del } from './requests'

export function deleteDocumentContactPlaceholder (documentId, contactPlaceholderId) {
  return del(`documents/${documentId}/contact_placeholders/${contactPlaceholderId}`)
}
